import { useCallback, useEffect } from 'react';
import { publicEventsAPIService } from 'js/services/publicEventsAPI.service';

/**
 * Event fires when user balance is updated.
 * @memberOf Playtech.API.events
 * @event lotto-analytics
 * @type {callback}
 * @param {Object} details
 * @param {string} details.eventName Name of the event.
 * @param {string} [details.userName] Current player's userName.
 * @param {string} details.currency Player's currency.
 * @param {string} details.page Page where the event was triggered.
 * @param {string} [details.data] Lotto data.
 * @param {Object|string} details.raw {Object|string} Other metadata.
 * @example Playtech.on('lotto-analytics', (data) => { ... });
 */

export const EVENT_LOTTO_ANALYTICS = 'lotto-analytics';

export const useOnLottoAnalytics = (eventTarget: EventTarget) => {
    const handleEvent = useCallback((response: {
        currency: string;
        data?: Record<string, any> | string;
        eventName: string;
        page: string;
        raw: Record<string, any> | string;
        userName?: string;
    }): void => {
        const event = new CustomEvent(EVENT_LOTTO_ANALYTICS, { detail: response });

        eventTarget.dispatchEvent(event);
    }, [eventTarget]);

    useEffect(() => {
        publicEventsAPIService.on(EVENT_LOTTO_ANALYTICS, handleEvent);

        return () => publicEventsAPIService.off(EVENT_LOTTO_ANALYTICS, handleEvent);
    }, [handleEvent]);
};
